import { render, staticRenderFns } from "./FrontpageUseful.vue?vue&type=template&id=cb5d6b80&"
import script from "./FrontpageUseful.vue?vue&type=script&lang=js&"
export * from "./FrontpageUseful.vue?vue&type=script&lang=js&"
import style0 from "./../styles/frontpage_useful.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports